'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Form = require('../vendor/canvas/Form');

var _Form2 = _interopRequireDefault(_Form);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UIForm = _react2.default.createClass({
  displayName: 'UIForm',
  render: function render() {
    var _props = this.props,
        className = _props.className,
        rest = _objectWithoutProperties(_props, ['className']);

    return _react2.default.createElement(_Form2.default, _extends({}, rest, { className: (0, _reactUtils.classNames)('private-form', className) }));
  }
});

UIForm.propTypes = _Form2.default.propTypes;
UIForm.defaultProps = _Form2.default.defaultProps;

exports.default = UIForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/form/UIForm.js
// module id = 343
// module chunks = 0